export default __webpack_public_path__ + "static/media/about-us-mobile-hero.12ba7acf.png";